import { AtualizarCidadaoAutistaRequest } from 'store/modules/api/iirgd/cidadaoAutista/atualizarCidadaoAutista/types';
import { CadastrarCidadaoAutistaRequest } from 'store/modules/api/iirgd/cidadaoAutista/cadastrarCidadaoAutista/types';
import {
	ConsultarCidadaoAutistaData,
	ConsultarCidadaoAutistaRequest,
} from 'store/modules/api/iirgd/cidadaoAutista/consultarCidadaoAutista/types';
import { Login } from 'store/modules/api/sgu/loginUnico/types';
import { verifyDateIsLowerCurrentDate } from 'utils/dateFunctions';
import {
	calcularIdade,
	convertDate,
	formatDate,
	limparMascara,
	validacaoData,
} from 'utils/genericFunctions';
import * as Yup from 'yup';

export interface CadastroCIPTEAFormValues {
	numeroRg: string;
	digitoRg: string;
	ciptea: boolean;
	dataValidade: string;
	responsavel: {
		cpf: string;
		nome: string;
		logradouro: string;
		logradouroNumero: string;
		logradouroComplemento: string;
		logradouroBairro: string;
		logradouroCEP: string;
		logradouroMunicipioCodigo: string;
		logradouroMunicipioDigito: string;
		celular: string;
		email: string;
	};
	possuiCarteirinha: string;
	codigoMunicipio: string;
	descMunicipio: string;
}

export const cidValuesCIPTEA = [
	'F84',
	'F84.0',
	'F84.1',
	'F84.2',
	'F84.3',
	'F84.4',
	'F84.5',
	'F84.6',
	'F84.8',
	'F84.9',
	'6A02',
	'6A02.0',
	'6A02.1',
	'6A02.2',
	'6A02.3',
	'6A02.4',
	'6A02.5',
	'6A02.Y',
	'6A02.Z',
];

export const messagesErrors = {
	CPFNotAllowed:
		'O CPF do responsável encontra-se com a situação irregular junto a RFB, o que impede a continuidade do cadastro.',
	notAllFieldsFilled: 'Dados do Responsável do Autista Incompleto.',
	duplicatedCPF: 'NÚMERO DO CPF DO RESPONSÁVEL É O MESMO CPF DO CIDADÃO.',
	invalidCPF: 'NÚMERO DO CPF DO RESPONSÁVEL É INVALIDO.',
	expiratedDateCards: 'DATA DE VALIDADE DA CARTEIRINHA VENCIDA.',
	invalidExpiratedDate: 'DATA DE VALIDADE INVÁLIDA.',
};

export const initialValues: CadastroCIPTEAFormValues = {
	numeroRg: '',
	digitoRg: '',
	ciptea: false,
	dataValidade: '',
	responsavel: {
		cpf: '',
		nome: '',
		logradouro: '',
		logradouroNumero: '',
		logradouroComplemento: '',
		logradouroBairro: '',
		logradouroCEP: '',
		logradouroMunicipioCodigo: '',
		logradouroMunicipioDigito: '',
		email: '',
		celular: '',
	},
	possuiCarteirinha: '',
	codigoMunicipio: '',
	descMunicipio: '',
};

export const nameInstanceRequest = 'iirgd-modal-ciptea';

export const treatInitialValues = (
	dataConsultarCidadoAutista: ConsultarCidadaoAutistaData,
	descMunicipio?: string,
): CadastroCIPTEAFormValues => {
	return {
		possuiCarteirinha: dataConsultarCidadoAutista.ciptea ? 'S' : 'N',
		numeroRg: dataConsultarCidadoAutista.numeroRg || '',
		digitoRg: dataConsultarCidadoAutista.digitoRg || '',
		ciptea: dataConsultarCidadoAutista.ciptea || false,
		dataValidade:
			(dataConsultarCidadoAutista.dataValidade &&
				formatDate(dataConsultarCidadoAutista.dataValidade)) ||
			'',
		responsavel: {
			cpf: dataConsultarCidadoAutista.responsavel?.cpf || '',
			nome: dataConsultarCidadoAutista.responsavel?.nome || '',
			logradouro: dataConsultarCidadoAutista.responsavel?.logradouro || '',
			logradouroNumero:
				(dataConsultarCidadoAutista.responsavel?.logradouroNumero &&
					Number(
						dataConsultarCidadoAutista.responsavel?.logradouroNumero,
					).toString()) ||
				'',
			logradouroComplemento:
				dataConsultarCidadoAutista.responsavel?.logradouroComplemento || '',
			logradouroBairro:
				dataConsultarCidadoAutista.responsavel?.logradouroBairro || '',
			logradouroCEP:
				dataConsultarCidadoAutista.responsavel?.logradouroCEP || '',
			logradouroMunicipioCodigo:
				dataConsultarCidadoAutista.responsavel?.logradouroMunicipioCodigo || '',
			logradouroMunicipioDigito:
				dataConsultarCidadoAutista.responsavel?.logradouroMunicipioDigito || '',
			email:
				(dataConsultarCidadoAutista.responsavel?.emailUsuario &&
					dataConsultarCidadoAutista.responsavel?.emailDominio &&
					`${dataConsultarCidadoAutista.responsavel.emailUsuario}@${dataConsultarCidadoAutista.responsavel.emailDominio}`) ||
				'',
			celular:
				(dataConsultarCidadoAutista.responsavel?.telefoneDDD &&
					dataConsultarCidadoAutista.responsavel?.telefoneNumero &&
					Number(
						dataConsultarCidadoAutista.responsavel.telefoneDDD,
					).toString() +
						dataConsultarCidadoAutista.responsavel.telefoneNumero) ||
				'',
		},
		codigoMunicipio:
			(dataConsultarCidadoAutista.responsavel?.logradouroMunicipioCodigo &&
				dataConsultarCidadoAutista.responsavel?.logradouroMunicipioDigito &&
				`${dataConsultarCidadoAutista.responsavel.logradouroMunicipioCodigo}-${dataConsultarCidadoAutista.responsavel.logradouroMunicipioDigito}`) ||
			'',
		descMunicipio: descMunicipio || '',
	};
};

export const treatGetRequestCidadaoAutista = (
	login: Login,
	completeRGNumber: string,
): ConsultarCidadaoAutistaRequest => {
	const [number, digit] = completeRGNumber.split('-');
	return {
		header: {
			usuario: login.mainframe.idUsuario,
			senha: login.mainframe.senhaMainFrame,
		},
		query: {
			numeroRg: number,
			digitoRg: digit,
		},
	};
};

export const treatPostUpdateRequestData = (
	login: Login,
	formValues: CadastroCIPTEAFormValues,
): CadastrarCidadaoAutistaRequest | AtualizarCidadaoAutistaRequest => {
	const [emailUsuario, emailDominio] = formValues.responsavel.email.split(
		'@',
	) || ['', ''];

	return {
		header: {
			usuario: login.mainframe.idUsuario,
			senha: login.mainframe.senhaMainFrame,
		},
		requestData: {
			numeroRg: formValues.numeroRg,
			digitoRg: formValues.digitoRg,
			ciptea: formValues.possuiCarteirinha === 'S',
			dataValidade:
				(formValues.dataValidade && convertDate(formValues.dataValidade)) ||
				null,
			responsavel: {
				cpf: limparMascara(formValues.responsavel.cpf) || '',
				nome: formValues.responsavel.nome.toUpperCase(),
				logradouro: formValues.responsavel.logradouro,
				logradouroNumero: formValues.responsavel.logradouroNumero,
				logradouroComplemento: formValues.responsavel.logradouroComplemento,
				logradouroBairro: formValues.responsavel.logradouroBairro,
				logradouroCEP: formValues.responsavel.logradouroCEP,
				logradouroMunicipioCodigo:
					formValues.responsavel.logradouroMunicipioCodigo,
				logradouroMunicipioDigito:
					formValues.responsavel.logradouroMunicipioDigito,
				telefoneDDD:
					(formValues.responsavel?.celular &&
						limparMascara(formValues.responsavel.celular).substring(0, 2)) ||
					'',
				telefoneNumero:
					(formValues.responsavel?.celular &&
						limparMascara(formValues.responsavel.celular).substring(2, 11)) ||
					'',
				emailUsuario,
				emailDominio,
			},
		},
	};
};

export const schema = Yup.object<CadastroCIPTEAFormValues>().shape({
	possuiCarteirinha: Yup.string().required(
		'Campo Obrigatório: Possui Carteirinha.',
	),

	dataValidade: Yup.string()
		.when(['possuiCarteirinha'], {
			is: (possuiCarteirinha: string | undefined) => possuiCarteirinha === 'S',
			then: (sch: any) =>
				sch.required('Campo Obrigatório: Validade da Carteirinha.'),
			otherwise: (sch: any) => sch.notRequired(),
		})
		.test(
			'test-invalid-expirated-date',
			messagesErrors.invalidExpiratedDate,
			(value: any) => {
				if (value) {
					if (limparMascara(value) === '') {
						return true;
					}
					return validacaoData(value);
				}
				return true;
			},
		)
		.test({
			name: 'validateExpirateDateCard',
			exclusive: true,
			message: messagesErrors.expiratedDateCards,
			test: (value: any) => {
				if (!value) return true;
				return !verifyDateIsLowerCurrentDate(value);
			},
		}),

	responsavel: Yup.object().when('$dataNascimento', {
		is: (dataNascimento: string | undefined) => {
			return dataNascimento ? calcularIdade(dataNascimento) < 16 : false;
		},
		then: (sch: any) =>
			sch.shape({
				nome: Yup.string().required('Nome do responsável é obrigatório'),
				cpf: Yup.string()
					.required('CPF do responsável é obrigatório')
					.test(
						'check-duplicate',
						messagesErrors.duplicatedCPF,
						function validarCPFDuplicado(
							this: Yup.TestContext,
							value: string | undefined | null,
						) {
							const context = this.options.context as any;
							const titularCPF = context?.cpf;

							if (!value || !titularCPF) return true;

							return limparMascara(value) !== limparMascara(titularCPF);
						},
					),
			}),
		otherwise: (sch: any) => sch.nullable().notRequired(),
	}),
});
